import React from 'react'
import CocktailLocationRouter from '../StoreLayouts/CocktailLayouts/CocktailLocationRouter'

class CocktailsHappyHour extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            cocktails: '',
            desserts: '',
            happyHours: '',
            location: ''
        }
    }
    getHappyHour = () => {
        const location = this.props.match.params.location
        const getLocationId = (location) => {
            if (location === 'pl1') {
                return '5c2bbcfb53352c57e74314ff'
            } else if (location === 'pl2') {
                return '5c2bbdff53352c57e7431500'
            } else if (location === 'pl3') {
                return '5c2bbffc53352c57e7431501'
            } else if (location === 'pl4') {
                return '5c2bc17e53352c57e7431502'
            } else if (location === 'pl5') {
                return '5c2bc31653352c57e7431503'
            } else if (location === 'pl6') {
                return '5c2bc3b553352c57e7431504'
            } else if (location === 'pl7') {
                return '5c2bc47d53352c57e7431505'
            } else if (location === 'pl8') {
                return '5c2bc51b53352c57e7431506'
            } else if (location === 'pl9') {
                return '5c2bc75953352c57e7431507'
            }
        }
        return getLocationId(location)
    }
    getHappyHourMenu = () => {
        let locationId = this.getHappyHour()
        const url = `https://beta.pizzaluce.com/api/location/${locationId}/full`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            let promos = data.location.promos
            let locationData = data.location
            this.setState({happyHours: promos, location: locationData})
            console.log(data.location.promos)

            return data
        })
    }
    getCockTailMenu = (cocktailMenuId) => {
        console.log(cocktailMenuId)
        const url = `https://pl-api-dev.herokuapp.com/api/untappd/menu/${cocktailMenuId}`
        return fetch(url)
        .then(res => res.json())
        .then(data => this.setState({cocktails: data.menu}))
    }
    getDessertMenu = () => {
        const dessertMenuId = '604a819b88b21f0999b915d3'
        const url = `https://pl-api-dev.herokuapp.com/api/menu/${dessertMenuId}/full`

        fetch(url)
        .then(res => res.json())
        .then(data => this.setState({desserts: data[0]}))
        .catch(err => err)
    }
    setMenusByLocation = (locationId) => {
        console.log(locationId)
        if (locationId === 'pl2' || locationId === "pl5"){
            console.log('no liquor')
        } else {
            this.getCockTailMenu()
            console.log('liquor')
        }
    }

    componentDidMount(){
        const locationId = this.props.match.params.location
        const menuId = this.props.match.params.menuId

        this.setMenusByLocation(locationId)
        this.getCockTailMenu(menuId)
        this.getHappyHourMenu()
        this.getDessertMenu()
    }
    render(){
        console.log(this.state)
        return (
           <CocktailLocationRouter 
                locationId={this.props.match.params.location}
                location={this.state.location}
                dessertMenu={this.state.desserts}
                cocktailMenu={this.state.cocktails}
                happyHours={this.state.happyHours}
               
           />
        )
    }
}
export default CocktailsHappyHour